import { getLabelMessage } from '@gef-ui/localization/messages';
import Dialog from '@mui/material/Dialog';
import DialogContentText from '@mui/material/DialogContentText';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import React from 'react';
import GcpProgress from '../GcpProgress';
const ModalLoader = ({ open, handleClose, text = getLabelMessage('common:loading'), DialogProps = {}, progress = /*#__PURE__*/ React.createElement(GcpProgress, null) })=>/*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: handleClose,
        ...DialogProps
    }, /*#__PURE__*/ React.createElement(Stack, {
        spacing: 3,
        direction: "column",
        sx: {
            justifyContent: 'center',
            alignItems: 'center',
            width: 380,
            minHeight: 235,
            py: 5,
            px: 3
        }
    }, progress, text && /*#__PURE__*/ React.createElement(DialogContentText, {
        variant: "body1",
        align: "center"
    }, text)));
ModalLoader.propTypes = {
    DialogProps: PropTypes.object,
    handleClose: PropTypes.func,
    open: PropTypes.bool,
    progress: PropTypes.element,
    text: PropTypes.string
};
export default ModalLoader;
